import { loadClientWidgets } from "../utils/loadClientWidgets";
import { widgetsDataCards } from "../widgets";

import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";

export const initClient = () => loadClientWidgets(widgetsDataCards);

initClient();

document.addEventListener('DOMContentLoaded', () => {});
